import React, { Component } from "react"

export default class Wootric extends Component {
	componentDidMount() {
		const { uid, email } = this.props
		let setupScript = document.createElement("script")
		setupScript.type = "text/javascript"
		setupScript.async = true
		setupScript.innerHTML = `
       wootric_survey_immediately = ${process.env
					.REACT_APP_WOOTRIC_SURVEY_IMMEDIATELY || false};
       window.wootricSettings = {
					email: '${email}',
					external_id: '${uid}',
          account_token: "${process.env.REACT_APP_WOOTRIC_ACCOUNT_TOKEN}",
      };
    `
		document.body.appendChild(setupScript)

		// Beacon
		let beacon = document.createElement("script")
		beacon.type = "text/javascript"
		beacon.async = true

		beacon.src = "https://disutgh7q0ncc.cloudfront.net/beacon.js"
		beacon.onload = function() {
			window.wootric("run")
		}
		document.body.appendChild(beacon)
	}

	render() {
		return <div />
	}
}



// WEBPACK FOOTER //
// ./src/vendor/Wootric.js